var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scustomers"},[_c('div',{staticClass:"scroll_bx"},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticClass:"user_icon",attrs:{"src":require(`@/assets/users/${item}`),"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }